"use strict";
const $ = window.jQuery;

// Меню авторизованного пользователя.

function updateBalance(balance) {
    if (balance.raw < 0) {
        $(".current-balance").text(balance.formatted).addClass("red");

        // balance on profile page is special case
        $(".current-balance.balance").removeClass("green");
    } else {
        $(".current-balance").text(balance.formatted).removeClass("red");

        // balance on profile page is special case
        $(".current-balance.balance").addClass("green");
    }
}

$(function () {
    $("#show-user-menu").click(function (e) {
        e.preventDefault();
        $("#user-menu").toggleClass("opened");
        if ($("#user-menu").hasClass("opened")) {
            $.ajax({
                url: "/profile/get-balance/",
                cache: false,
                success: function (data) {
                    updateBalance(data.balance);
                },
            });
        }
    });

    $(document).on("click", function (e) {
        // hide user menu on click on outside area
        if (!$(e.target).is("#show-user-menu") && !$(e.target).parent().is("#show-user-menu")) {
            $("#user-menu").removeClass("opened");
        }
    });
}); // end of dom ready

export default {};
